/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const createTypesBodyContainsMax = 200;

export const createTypesBodyIncludesMax = 200;

export const createTypesBodyNodesItemClientIdMax = 36;

export const createTypesBodyNodesItemClientIdRegExp = new RegExp('^[a-z0-9._:-]+$');

export const createTypesBodyNodesItemTypeDefinitionReferenceViewPredicatesItemPathTypeUuidsMax = 8;

export const createTypesBodyNodesItemTypeDefinitionReferenceViewPredicatesMax = 10;

export const createTypesBodyNodesItemTypeDefinitionReferenceViewSearchTermsItemMax = 200;

export const createTypesBodyNodesItemTypeDefinitionReferenceViewSearchTermsMax = 10;

export const createTypesBodyNodesMax = 100;

export const createTypesBodyRelatesToMax = 200;

export const CreateTypesBody = zod.object({
  contains: zod
    .array(
      zod.object({
        edgeDescription: zod
          .string()
          .nullish()
          .describe(
            'Free-text description of the edge, stored verbatim. Omit to keep the stored description of an existing attachment (on PATCH, and on a create-graph command that re-asserts an existing parent\/target pair); a NEW attachment that omits it stores none. null clears it.',
          ),
        edgeKey: zod
          .string()
          .nullish()
          .describe(
            'Schema field key (lower snake_case, letter first) for a CONTAINS\/INCLUDES edge between TYPEs. Omit to keep the stored key of an existing attachment (on PATCH, and on a create-graph command that re-asserts an existing parent\/target pair); only a NEW attachment that omits it derives the key from the target type name. null is rejected on CONTAINS\/INCLUDES on both commands (a schema field always has a key) and clears the key on RELATES_TO.',
          ),
        from: zod
          .string()
          .min(1)
          .optional()
          .describe(
            'Source node: an existing content UUID, or — on the create endpoints only — a node clientId from this request. When omitted it defaults to the root (first) node on create, and to the TYPE being updated on PATCH \/types\/{uuid}.',
          ),
        max: zod.int().nullish().describe('Maximum cardinality (lowered to the edge maxCount).'),
        min: zod.int().nullish().describe('Minimum cardinality (lowered to the edge minCount).'),
        position: zod.int().nullish(),
        to: zod
          .string()
          .min(1)
          .describe(
            'Target node: an existing content UUID, or — on the create endpoints only — a node clientId from this request. A PATCH carries no nodes, so there it is always an existing UUID.',
          ),
      }),
    )
    .max(createTypesBodyContainsMax)
    .optional(),
  includes: zod
    .array(
      zod.object({
        edgeDescription: zod
          .string()
          .nullish()
          .describe(
            'Free-text description of the edge, stored verbatim. Omit to keep the stored description of an existing attachment (on PATCH, and on a create-graph command that re-asserts an existing parent\/target pair); a NEW attachment that omits it stores none. null clears it.',
          ),
        edgeKey: zod
          .string()
          .nullish()
          .describe(
            'Schema field key (lower snake_case, letter first) for a CONTAINS\/INCLUDES edge between TYPEs. Omit to keep the stored key of an existing attachment (on PATCH, and on a create-graph command that re-asserts an existing parent\/target pair); only a NEW attachment that omits it derives the key from the target type name. null is rejected on CONTAINS\/INCLUDES on both commands (a schema field always has a key) and clears the key on RELATES_TO.',
          ),
        from: zod
          .string()
          .min(1)
          .optional()
          .describe(
            'Source node: an existing content UUID, or — on the create endpoints only — a node clientId from this request. When omitted it defaults to the root (first) node on create, and to the TYPE being updated on PATCH \/types\/{uuid}.',
          ),
        max: zod.int().nullish().describe('Maximum cardinality (lowered to the edge maxCount).'),
        min: zod.int().nullish().describe('Minimum cardinality (lowered to the edge minCount).'),
        position: zod.int().nullish(),
        to: zod
          .string()
          .min(1)
          .describe(
            'Target node: an existing content UUID, or — on the create endpoints only — a node clientId from this request. A PATCH carries no nodes, so there it is always an existing UUID.',
          ),
      }),
    )
    .max(createTypesBodyIncludesMax)
    .optional(),
  nodes: zod
    .array(
      zod.object({
        clientId: zod
          .string()
          .min(1)
          .max(createTypesBodyNodesItemClientIdMax)
          .regex(createTypesBodyNodesItemClientIdRegExp)
          .describe(
            'Caller-supplied temporary node reference, unique within the request. Used to wire edges and to look up the created UUID in the response. Use lowercase letters, numbers, dots, underscores, colons, or hyphens.',
          ),
        contentTypeUuid: zod
          .uuid()
          .optional()
          .describe(
            "Optional reference to another TYPE — a complex type's field slot points at the primitive it instantiates, or a parent TYPE for type→type grouping.",
          ),
        typeDefinition: zod
          .object({
            conformance: zod.enum(['open', 'lax', 'strict']).optional(),
            description: zod.string().nullish(),
            enumOptions: zod
              .array(zod.string().min(1))
              .optional()
              .describe(
                'Ordered choice values for an ENUM type (one string per option). Stored as { value, label } with value === label.',
              ),
            file: zod
              .object({
                allowedFormats: zod
                  .array(
                    zod.enum([
                      'pdf',
                      'doc',
                      'docx',
                      'xls',
                      'xlsx',
                      'csv',
                      'txt',
                      'jpeg',
                      'png',
                      'webp',
                      'gif',
                      'heic',
                      'md',
                      'html',
                      'mp3',
                      'm4a',
                      'wav',
                      'mp4',
                      'mov',
                      'webm',
                    ]),
                  )
                  .min(1)
                  .optional(),
              })
              .nullish()
              .describe(
                'File config for a STRING type whose instances hold uploaded files. allowedFormats narrows the platform allowlist to a subset of format ids; omitted, the field accepts every platform-supported format. Pass null to clear a stored config; omit to keep it.',
              ),
            reference: zod
              .object({
                carbonCopy: zod.boolean().optional(),
                creation: zod.enum(['forbidden', 'optional', 'required']).optional(),
                edgeType: zod.enum(['INCLUDES', 'RELATES_TO']).optional(),
                typeLineageUuid: zod.uuid(),
                typeUuid: zod.uuid(),
                view: zod
                  .object({
                    predicates: zod
                      .array(
                        zod.object({
                          op: zod.enum(['exists', 'eq', 'contains', 'gte', 'lte']),
                          pathTypeUuids: zod
                            .array(zod.uuid())
                            .min(1)
                            .max(
                              createTypesBodyNodesItemTypeDefinitionReferenceViewPredicatesItemPathTypeUuidsMax,
                            ),
                          value: zod.string().optional(),
                          valueType: zod
                            .enum(['STRING', 'NUMERIC', 'BOOLEAN', 'DATE', 'DATETIME'])
                            .optional(),
                        }),
                      )
                      .max(createTypesBodyNodesItemTypeDefinitionReferenceViewPredicatesMax)
                      .optional(),
                    searchTerms: zod
                      .array(
                        zod
                          .string()
                          .min(1)
                          .max(
                            createTypesBodyNodesItemTypeDefinitionReferenceViewSearchTermsItemMax,
                          ),
                      )
                      .max(createTypesBodyNodesItemTypeDefinitionReferenceViewSearchTermsMax)
                      .optional(),
                  })
                  .nullish(),
              })
              .nullish()
              .describe(
                "Reference config for a STRING type whose instances point at another TYPE's instances. Pass null to clear a stored config; omit to keep it.",
              ),
          })
          .optional(),
        typeName: zod.string().min(1).describe('Schema field\/type name for this TYPE node.'),
        value: zod
          .object({
            booleanValue: zod.boolean().nullish(),
            dateValue: zod.string().nullish(),
            datetimeValue: zod.string().nullish(),
            jsonValue: zod.unknown().optional(),
            numericValue: zod.number().nullish(),
            stringValue: zod.string().nullish(),
          })
          .optional(),
        valueType: zod
          .enum(['STRING', 'NUMERIC', 'BOOLEAN', 'DATE', 'DATETIME', 'ENUM', 'JSON'])
          .optional()
          .describe('Datatype of a TYPE leaf field.'),
      }),
    )
    .min(1)
    .max(createTypesBodyNodesMax),
  performAs: zod
    .object({
      actorUuid: zod.uuid().optional().describe('UUID v4 identifier'),
      principalType: zod.enum(['USER', 'GROUP', 'GROUP_MEMBER']),
    })
    .optional(),
  relatesTo: zod
    .array(
      zod.object({
        edgeDescription: zod
          .string()
          .nullish()
          .describe(
            'Free-text description of the edge, stored verbatim. Omit to keep the stored description of an existing attachment (on PATCH, and on a create-graph command that re-asserts an existing parent\/target pair); a NEW attachment that omits it stores none. null clears it.',
          ),
        edgeKey: zod
          .string()
          .nullish()
          .describe(
            'Schema field key (lower snake_case, letter first) for a CONTAINS\/INCLUDES edge between TYPEs. Omit to keep the stored key of an existing attachment (on PATCH, and on a create-graph command that re-asserts an existing parent\/target pair); only a NEW attachment that omits it derives the key from the target type name. null is rejected on CONTAINS\/INCLUDES on both commands (a schema field always has a key) and clears the key on RELATES_TO.',
          ),
        from: zod
          .string()
          .min(1)
          .optional()
          .describe(
            'Source node: an existing content UUID, or — on the create endpoints only — a node clientId from this request. When omitted it defaults to the root (first) node on create, and to the TYPE being updated on PATCH \/types\/{uuid}.',
          ),
        max: zod.int().nullish().describe('Maximum cardinality (lowered to the edge maxCount).'),
        min: zod.int().nullish().describe('Minimum cardinality (lowered to the edge minCount).'),
        position: zod.int().nullish(),
        to: zod
          .string()
          .min(1)
          .describe(
            'Target node: an existing content UUID, or — on the create endpoints only — a node clientId from this request. A PATCH carries no nodes, so there it is always an existing UUID.',
          ),
      }),
    )
    .max(createTypesBodyRelatesToMax)
    .optional(),
});

export type CreateTypesBody = zod.input<typeof CreateTypesBody>;
export type CreateTypesBodyOutput = zod.output<typeof CreateTypesBody>;
